const InventoryItemTypes = require('../constants/inventoryItemTypes');

module.exports = {
  REAL_ESTATE: '00',
  NATURAL_RESOURCE: '01',
  CORRIDOR: '02',
  TERRITORY: '03',
  RELATIONSHIP: '04',
};
